
export const root = {
    background: '{form.field.background}',
    disabledBackground: '{form.field.disabled.background}',
    filledBackground: '{form.field.filled.background}',
    filledHoverBackground: '{form.field.filled.hover.background}',
    filledFocusBackground: '{form.field.filled.focus.background}',
    borderColor: '{form.field.border.color}',
    hoverBorderColor: '{form.field.hover.border.color}',
    focusBorderColor: '{form.field.focus.border.color}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    color: '{form.field.color}',
    disabledColor: '{form.field.disabled.color}',
    placeholderColor: '{form.field.placeholder.color}',
    invalidPlaceholderColor: '{form.field.invalid.placeholder.color}',
    shadow: '{form.field.shadow}',
    paddingX: '{form.field.padding.x}',
    paddingY: '{form.field.padding.y}',
    borderRadius: '{form.field.border.radius}',
    fontSize: '{form.field.font.size}',
    fontWeight: '300',
    focusRing: {
        width: '{form.field.focus.ring.width}',
        style: '{form.field.focus.ring.style}',
        color: '{form.field.focus.ring.color}',
        offset: '{form.field.focus.ring.offset}',
        shadow: '{form.field.focus.ring.shadow}'
    },
    transitionDuration: '{form.field.transition.duration}',
    sm: {
        fontSize: '{form.field.sm.font.size}',
        paddingX: '{form.field.sm.padding.x}',
        paddingY: '{form.field.sm.padding.y}'
    },
    lg: {
        fontSize: '{form.field.lg.font.size}',
        paddingX: '{form.field.lg.padding.x}',
        paddingY: '{form.field.lg.padding.y}'
    }
};

export const dropdown = {
    width: '2.5rem',
    color: '{form.field.icon.color}'
};

export const overlay = {
    background: '{dropdown.background}',
    borderColor: '{dropdown.border.color}',
    borderRadius: '{dropdown.border.radius}',
    color: '{dropdown.color}',
    shadow: '{dropdown.shadow}'
};

export const list = {
    padding: '{list.padding}',
    gap: '{list.gap}',
    header: {
        padding: '{list.header.padding}'
    }
};

export const option = {
    focusBackground: '{dropdown.item.focus.background}',
    selectedBackground: '{dropdown.item.selected.background}',
    selectedFocusBackground: '{dropdown.item.selected.focus.background}',
    color: '{dropdown.item.color}',
    focusColor: '{dropdown.item.focus.color}',
    selectedColor: '{dropdown.item.selected.color}',
    selectedFocusColor: '{dropdown.item.selected.focus.color}',
    padding: '{dropdown.item.padding}',
    borderRadius: '{dropdown.item.border.radius}'
};

export const optionGroup = {
    background: '{list.option.group.background}',
    color: '{list.option.group.color}',
    fontWeight: '{list.option.group.font.weight}',
    padding: '{list.option.group.padding}'
};

export const clearIcon = {
    color: '{form.field.icon.color}'
};

export const checkmark = {
    color: '{list.option.color}',
    gutterStart: '-0.5rem',
    gutterEnd: '0.5rem'
};

export const emptyMessage = {
    padding: '{list.option.padding}'
};

export const colorScheme = {
    dark: {
        root: {
            borderColor: '{surface.600}',
            hoverBorderColor: '{surface.500}',
            focusBorderColor: '{primary.color}'
        }
        // overlay and option now inherit from {dropdown.*} tokens in base theme
    }
};

// PrimeNG hardcodes font-size: 1rem on .p-select-label — override via css callback
export const css = ({dt}: {dt: (token: string) => string}) => `
.p-select-label {
    font-size: ${dt('select.font.size')};
    font-weight: ${dt('select.font.weight')};
}
`;

export default {
    root,
    dropdown,
    overlay,
    list,
    option,
    optionGroup,
    clearIcon,
    checkmark,
    emptyMessage,
    colorScheme,
    css
};
